module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00408.a9be5003.jpg";